export class ChatSender {
    constructor(icon, nickname, type) {
        this.icon = icon;
        this.nickname = nickname;
        this.type = type;
    }
    static equals(a, b) {
        return a.icon === b.icon && a.nickname === b.nickname && a.type === b.type;
    }
}
